'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InterDialog = require('./InterDialog');

var _InterDialog2 = _interopRequireDefault(_InterDialog);

var _Filter = require('./Filter/Filter');

var _Filter2 = _interopRequireDefault(_Filter);

var _Sorter = require('./Sorter/Sorter');

var _Sorter2 = _interopRequireDefault(_Sorter);

var _show = require('./show.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_InterDialog2.default.Filter = _Filter2.default;
_InterDialog2.default.Sorter = _Sorter2.default;

_InterDialog2.default.alert = _show.alert;
_InterDialog2.default.confirm = _show.confirm;
_InterDialog2.default.warning = _show.warning;

exports.default = _InterDialog2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-inter-dialog@0.0.46@@alicd/crui-inter-dialog/lib/index.js
// module id = 635
// module chunks = 0